export {};

const onmount = require('onmount');

const FORM_ID = '#lj-anonymousFooter-hubspotForm';
const SCRIPT_SRC = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
const SCRIPT_FLAG = '__ljHubspotLoaded';

const HUBSPOT_FORM_CONFIG = {
  portalId: '25245493',
  formId: 'a216f2c3-c5b9-4bed-ab97-47f414222553',
  region: 'eu1',
  target: FORM_ID
};

function renderForm() {
  const hbspt = (window as any).hbspt;
  if (typeof hbspt === 'undefined') return;
  if (document.querySelector(`${FORM_ID} iframe, ${FORM_ID} form`)) return;

  hbspt.forms.create({
    ...HUBSPOT_FORM_CONFIG,
    onFormReady(form: any) {
      // HubSpot passes a jQuery-wrapped form; `.length` unwrap works for both
      // jQuery objects and DOM elements, `Array.isArray` would not.
      const formEl: HTMLElement | null = form && form.length ? form[0] : form;
      if (!formEl) return;
      // Opt out of the global spinner — HubSpot blocks submit on validation
      // failure but emits no event to stop the spinner from spinning forever.
      const submit = formEl.querySelector('input[type="submit"]');
      if (submit) submit.setAttribute('data-spinner', 'false');
    }
  });
}

function loadHubspotScript() {
  if ((window as any)[SCRIPT_FLAG]) {
    renderForm();
    return;
  }
  (window as any)[SCRIPT_FLAG] = true;

  const script = document.createElement('script');
  script.src = SCRIPT_SRC;
  script.charset = 'utf-8';
  script.type = 'text/javascript';
  script.onload = renderForm;
  document.head.appendChild(script);
}

// The form sits in the footer, below the fold on every page it appears on, but
// its embed script is 199 KiB and competes with the initial render. Hold it
// back until the footer is close to being scrolled into view.
function loadWhenApproaching(target: Element) {
  if (typeof IntersectionObserver === 'undefined') {
    loadHubspotScript();
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;

      observer.disconnect();
      loadHubspotScript();
    },
    { rootMargin: '400px' }
  );

  observer.observe(target);
}

onmount(FORM_ID, function () {
  loadWhenApproaching(this as HTMLElement);
});
